import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const removeStructureColumnStmtInstruction = `
#### Remove column

- Syntax: \`remove column <column_name> in <view_name>.<scope_name>;\`
- Example: \`remove column name in ProductList.ProductScope;\`
`;
export const stmtRemoveStructureColumn = ({ columnName, scopeName, viewName }) => {
    return `remove column ${columnName} in ${viewName}.${scopeName};`;
};
export const removeStructureColumnHandler = createStructureStatementHandler({
    type: 'remove column',
    parse: line => {
        const match = /^remove column (?<columnName>[\w.]+) in (?<viewName>\w+)\.(?<scopeName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove column',
                columnName: match.groups.columnName,
                viewName: match.groups.viewName,
                scopeName: match.groups.scopeName,
            }
            : null;
    },
    apply: (stmt, builder) => builder.updateStructure(it => it.removeColumn({
        columnName: stmt.columnName,
        viewName: stmt.viewName,
        scopeName: stmt.scopeName,
    })),
});
//# sourceMappingURL=RemoveColumnStmt.js.map